<div class="root">
  <img src="../../../assets/imgs/shelfy-logo.png" />
</div>
